import React, {useState} from 'react';
import settingIcon from '../../../../asset/images/setting.png'
export const AppSetting =(props)=>{
    const [openMenu,setOpenMenu]=useState(false);
    return <div onMouseLeave={()=>setOpenMenu(false)} >
                {/* <div className="setting-image" onClick={()=>{setOpenMenu(!openMenu)}} >
                    <img src={settingIcon} alt="setting-image"  onClick={()=>{setOpenMenu(!openMenu)}}/>
                </div> */}
                <div>
                {/* <div className="settings-text-icon" style={openMenu===true?{display:"block"}:{display:"none"}} /> */}
                {/* <div className="seting-content-text" style={openMenu===true?{display:"block"}:{display:"none"}}>
                    <span>Setting</span>
                    <span>Basic Setting</span>
                    <span>Lorem Ipsum</span>
                    <span>Basic Setting</span>
                    <span>View More</span>
                </div> */}
                </div>
            </div>
}
export default AppSetting;